import styled from "styled-components"
import useOutsideClick from "../utils/useOutsideClick"

const Container = styled.div`
    background-color: white;
    border: 0.125rem solid #B3B3B3;  
    width: fit-content;
    z-index: 100;
    display: grid;
    grid-template-columns: ${props => `repeat(${props.cols}, min-content)`}; 
    gap: 1rem;
    padding: 1rem;
    border-radius: 0.5rem;
`

const Item = styled.div`
    display: flex;
    text-align: center;
    font-size: 1.5rem;
    font-family: 'Pretendard Variable';
    cursor: pointer;
    display: inline-block; 
    white-space: nowrap;
`

const SelectedItem = styled(Item)`
    font-weight: 600;
    color: #A939FF;
`

const UnselectedItem = styled(Item)`
    font-weight: 300;
    color: #B3B3B3;
`

export function SelectPopup({ isVisible, gridCols, items, initialValue, onClose, onSelect} ) {

    const dialogRef = useOutsideClick(onClose);

    return (
        isVisible && <Container ref={dialogRef} cols={gridCols}> 
            {items.map((item, index) => {
                const isSelected = item === initialValue;
                const ItemComponent = isSelected ? SelectedItem : UnselectedItem;
                return (
                    <ItemComponent key={index} onClick={() => onSelect(item)}>
                        {item === null ? "없음" : item}
                    </ItemComponent>
                );
            })}
        </Container>
    )
}